import React from 'react'

import { useI18N } from '../../../libraries/i18n/hook'

type Props = { amount: number }
const ResultsLabel: React.FC<Props> = ({ amount }) => {
  const { t } = useI18N()
  const label = amount === 1 ? t('content.result') : t('content.result_plural')
  return (
    <small className='text-black'>{amount} {label}</small>
  )
}

export default ResultsLabel
